export default __webpack_public_path__ + "static/DIN-Medium-072f14dd5f9e5c84129bca9d1ed156f4.woff";